import React from 'react';

import { Box } from '@/box';
import { Caption } from '@/ui/typography';

interface MembershipDiscountBadgeProps {
  text: string;
  backgroundColor?: string;
  color?: string;
}

export const MembershipDiscountBadge = ({
  text,
  backgroundColor = '#143C21',
  color = '#FFF',
}: MembershipDiscountBadgeProps) => {
  return (
    <Box
      css={{
        backgroundColor,
        padding: '10px',
        borderRadius: '4px',
        boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.25)',
      }}
    >
      <Caption
        uppercase
        css={{
          color: `${color} !important`,
          fontWeight: 'bold',
          lineHeight: '9px',
          letterSpacing: '0.5px',
        }}
      >
        {text}
      </Caption>
    </Box>
  );
};
